import React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
const EditDestination = () => {
  let params = useParams();
  useEffect(() => {}, [params]);
  return <div>editlencek sayfa {params.id} </div>;
};

export default EditDestination;
